module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-500.991b453bf90a0980e78966d2af7e3d3a.woff";